import React, { useContext } from 'react';
import * as styles from './index.module.less';
import PricingBtn from '@/components/pricing-btn';
import { GOODS_TYPE } from '@/modules/pricing/utils';
import { PricingContext } from '@/modules/pricing-v2/provider';
import ButtonWithArrow from '@/components/button-with-arrow';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { FREE_BTN_LABEL } from '@/modules/pricing-v2/constants';

interface ICardBtnContainer {
  btnLabel: string;
  index: number;
  type: GOODS_TYPE;
}

const EDUCATION_BTN = {
  [GOODS_TYPE.PRO]: {
    label: 'subscribe_students_educators_discount',
    link: '/education-plan',
  },
  [GOODS_TYPE.TEAM]: {
    label: 'subscribe_education_plan_teams_label',
    link: 'https://share.hsforms.com/1eZ-FMZtmS4GceU04mI3J1Anoue6',
  },
};

const CardBtnContainer = ({ btnLabel, index, type }: ICardBtnContainer) => {
  const { getUpgradeLink, lang } = useContext(PricingContext);
  const { t } = useTranslation();

  return (
    <div
      style={{
        gridArea: `b${index}`,
      }}
      className={styles.btn_wrapper}
    >
      <PricingBtn link={getUpgradeLink(type)} type={type} lang={lang}>
        {type === GOODS_TYPE.FREE ? FREE_BTN_LABEL[lang] : btnLabel}
      </PricingBtn>
      {lang === 'ja' && (type === GOODS_TYPE.PRO || type === GOODS_TYPE.TEAM) && (
        <ButtonWithArrow
          link={EDUCATION_BTN[type].link}
          target="_blank"
          size="small"
          className={styles.education_plan_btn}
        >
          {t(EDUCATION_BTN[type].label)}
        </ButtonWithArrow>
      )}
    </div>
  );
};
export default CardBtnContainer;
